export const forgetPasswordTypes = {
    FORGET_PASSWORD_REQUEST: 'USER_FORGET_PASSWORD_REQUEST',
    FORGET_PASSWORD_SUCCESS: 'USER_FORGET_PASSWORD_SUCCESS',
    FORGET_PASSWORD_FAILURE: 'USER_FORGET_PASSWORD_FAILURE',

    SET_ERROR: 'USER_FORGET_PASSWORD_SET_ERROR',
    REMOVE_ERRORS: 'USER_FORGET_PASSWORD_REMOVE_ERRORS',

    UNKNOWN_ERROR: "USER_FORGET_PASSWORD_UNKNOWN_ERROR",
    UNKNOWN_ERROR_MESSAGE: "OOPS! Something went wrong"
};
